import React from 'react';
import NavBar from './navbar/NavBar';
import { IoMdClose } from 'react-icons/io';
import '../style/Ueberuns.scss';
import ueberuns from '../assets/02_ueberuns/ueberuns.jpg';
import bild1 from '../assets/02_ueberuns/bild1.jpg';
import bild2 from '../assets/02_ueberuns/bild2.jpg';
import bild3 from '../assets/02_ueberuns/bild3.jpg';
import bild4 from '../assets/02_ueberuns/bild4.jpg';
import bild6 from '../assets/02_ueberuns/bild6.jpg';
import bild7 from '../assets/02_ueberuns/bild7.jpg';
import bild8 from '../assets/02_ueberuns/bild8.jpg';
import bild9 from '../assets/02_ueberuns/bild9.jpg';
import bild10 from '../assets/02_ueberuns/bild10.jpg';
import bild11 from '../assets/02_ueberuns/bild11.jpg';
import { useNavigate } from "react-router-dom";

function Ueberuns() {
    const navigate = useNavigate();

    function closeMenu() {
        document.getElementById('menu').style.visibility = 'hidden';
        document.getElementById('fabars').style.visibility = 'visible';
        document.getElementById('fabars2').style.visibility = 'visible';
    }

    function navigate0() {
        navigate("/");
    }

    function navigate1() {
        navigate("/ueber-uns");
    }

    function navigate2() {
        navigate("/referenzen");
    }

    function navigate3() {
        navigate("/kontakt");
    }

    return (
        <div className='App'>
            <div id='menu' className='menu'>
                <div className='menu-esc-container'>
                    <div className='menu-esc' onClick={closeMenu}>
                        <IoMdClose size={'6vh'}/>
                    </div>
                </div>
                <div className='menu-items-container'>
                    <div className='menu-item' onClick={navigate0} >Home</div>
                    <div className='menu-item' onClick={navigate1} >Über uns</div>
                    <div className='menu-item' onClick={navigate2} >Referenzen</div>
                    <div className='menu-item' onClick={navigate3} >Kontakt</div>
                </div>
            </div>
            <NavBar />
            <div className='header'>
                <img className='image' src={ueberuns} alt=''></img>
            </div>
            <div className='body'>
                <div className='title-block'>
                    Über uns
                </div>
                <div className='überuns-text'>
                Neugierig, voller Freude, verspielt, musikalisch, etwas tollpatschig, auch mal wütend oder traurig – so sind wir - Ambrella und Schubi-Dubi.
                <br></br>
                <br></br>
                Ja, das Clownspiel wurde zu unserer grossen Leidenschaft! Unser Glaube an Jesus Christus inspiriert uns und natürlich bringen auch unsere drei Kinder uns immer mal wieder auf lustige Ideen 😊
                </div>
                <div className="ueberuns-text2">
                    <table className="ueberuns-table">
                        <tbody>
                        <tr>
                            <td className="ueberuns-table-date">2020–2022</td>
                            <td className="ueberuns-table-text">
                            Ausbildung zum Bühnenclown in Basel an der Theater- und Clownschule Yve Stöcklin.
                            </td>
                        </tr>
                        <tr>
                            <td className="ueberuns-table-date">2022</td>
                            <td className="ueberuns-table-text">
                            Weiterbildung zum Besuchs-Clown an der Antiheldenakademie in Augsburg.
                            </td>
                        </tr>
                        <tr>
                            <td className="ueberuns-table-date">Seit 2022</td>
                            <td className="ueberuns-table-text">
                            Sind wir regelmässig im Alters- und Pflegeheim unterwegs.
                            </td>
                        </tr>
                        <tr>
                            <td className="ueberuns-table-date">Seit 2024</td>
                            <td className="ueberuns-table-text">
                            Treffen wir uns 1× monatlich zum Clown-Training mit anderen Clowns.
                            </td>
                        </tr>
                        <tr>
                            <td className="ueberuns-table-date">2026</td>
                            <td className="ueberuns-table-text">
                            Lukas: Weiterbildung – Anwendbare Zauberei (Schwager Theater)
                            </td>
                        </tr>
                        <tr>
                            <td className="ueberuns-table-date">2026</td>
                            <td className="ueberuns-table-text">
                            Damaris: Weiterbildung – Clown und Musik (ClownWerk)
                            </td>
                        </tr>
                        <tr>
                            <td className="ueberuns-table-date">2026–2027</td>
                            <td className="ueberuns-table-text">
                            Damaris: Ausbildung zum Humorcoach
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className='gallery-block-container'>
                    <div className='gallery-block'>
                        <div className='gallery-img'>
                            <img className='image' src={bild1} alt=''></img>
                        </div>
                        <div className='gallery-img'>
                            <img className='image' src={bild2} alt=''></img>
                        </div>
                        <div className='gallery-img'>
                            <img className='image' src={bild3} alt=''></img>
                        </div>
                        <div className='gallery-img'>
                            <img className='image' src={bild4} alt=''></img>
                        </div>
                        <div className='gallery-img'>
                            <img className='image' src={bild6} alt=''></img>
                        </div>
                        <div className='gallery-img'>
                            <img className='image' src={bild7} alt=''></img>
                        </div>
                        <div className='gallery-img'>
                            <img className='image' src={bild8} alt=''></img>
                        </div>
                        <div className='gallery-img'>
                            <img className='image' src={bild9} alt=''></img>
                        </div>
                        <div className='gallery-img'>
                            <img className='image' src={bild10} alt=''></img>
                        </div>
                        <div className='gallery-img'>
                            <img className='image' src={bild11} alt=''></img>
                        </div>
                    </div>
                </div>
            </div>
            <div className='footer'>
                Copyright {new Date().getFullYear()} © Damaris & Lukas Steiner
            </div>
        </div>
    );
}

export default Ueberuns;